export default __webpack_public_path__ + "static/media/infra-25.258c0221.webp";